import { ArrowRight } from "lucide-react";
import { PRICE_NEW } from "../../lib/site";

export const CtaButton = ({ onBuy, testid, label }) => (
  <button
    data-testid={testid}
    onClick={onBuy}
    className="group inline-flex items-center gap-2.5 rounded-full bg-choc px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-choc-deep sm:text-base"
  >
    {label || `Kup teraz — ${PRICE_NEW}`}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </button>
);
